import React, { Fragment, useEffect } from 'react'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'

import useAsnBlogs from './useAsnBlog'

interface AsnBlogProps {
  asnId: number
  asnNumber: string
}

export const AsnBlogDetailAsn: React.FC<AsnBlogProps> = ({ asnId, asnNumber }) => {
  const { errorGetAsn, asnBlogs, getAsnBlogs } = useAsnBlogs()

  useEffect(() => {
    getAsnBlogs(asnId, asnNumber)
  }, [getAsnBlogs])

  const asnBlogsFilterDistinct = Array.from(
    new Set(asnBlogs.map((x) => x.asnState))
  ).map((asnState) => {
    return {
      asnState: asnState,
      createdUser: asnBlogs.find((s) => s.asnState === asnState)?.createdUser,
      createdDate: asnBlogs.find((s) => s.asnState === asnState)?.createdDate
    }
  })
  return (
    <Fragment>
      <Grid
        container
        xs={12}
        sm={12}
        md={12}
        lg={12}
        spacing={1}
        style={{ paddingLeft: '20px' }}
      >
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Typography variant='body2' component='p'>
            <b>Estado</b>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Typography variant='body2' component='p'>
            <b>Fecha</b>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Typography variant='body2' component='p'>
            <b>Usuario</b>
          </Typography>
        </Grid>
        {errorGetAsn !== undefined && (
          <Fragment>
            <Grid item xs={12} sm={12} md={4} lg={2}></Grid>
            <Grid item xs={12} sm={12} md={4} lg={8}>
              <b>{errorGetAsn}</b>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={2}></Grid>
          </Fragment>
        )}
        {errorGetAsn === undefined &&
          asnBlogsFilterDistinct.length > 0 &&
          asnBlogsFilterDistinct.map(
            ({ createdDate, asnState, createdUser }) => (
              <Fragment>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                  <Typography variant='body2' component='p'>
                    {asnState}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                  <Typography variant='body2' component='p'>
                    {createdDate!.substr(0, 10).split('-').reverse().join('.')}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                  <Typography variant='body2' component='p'>
                    {createdUser}
                  </Typography>
                </Grid>
              </Fragment>
            )
          )}
      </Grid>
    </Fragment>
  )
}
